
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

const  DeleteConfirmModal=(props) =>{
    
    return(
        <Dialog
        className="cstm_dialog_modal small text-center"
        open={props.openAlerModal}
        // onClose={props.handleCloseAlertModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <div className='heading_holder flex justify-end items-center w-full'>
            <Button className='transparent_icon_btn' onClick={props.handleCloseAlertModal}>
              <i className="icon ti ti-x" />
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="warning_content_holder">
            <div className="exclamation_icon_holder red">
              <i className="ti ti-exclamation-mark" />
            </div>
            <h2 className="heading">{props.module !== 'Site Details' ? `Are you sure to delete the ${props.module}?` : 'Are you sure you want to proceed?'}</h2>
            <p className="sub_content">{props.module !== 'Site Details' ? 'You will lose the data if you proceed' : 'Removing this Site ID will stop monitoring all network devices associated with this site.'} </p>
          </div>
        </DialogContent>
        <DialogActions className="action_footer_holder">
          <Button onClick={props.handleCloseAlertModal} className="secondary_btn">No, go back!</Button>
          <Button onClick={props.handleAlertModal} className="primary_btn">
            Yes, Proceed!
          </Button>
        </DialogActions>
      </Dialog>
    )
}

export default  DeleteConfirmModal